import { Grid } from "@mui/material";
import { IWhatsAppTemplate } from "../../../redux/whatsappTemplate/whatsappTemplate.types";
// import { MarketCampaignContext } from "../../market-campaign/MarketCampaign.context-state";
// import { mockCampaignContext } from "../../../helpers/mockCampaignContext";
// import { Step3MarketCampaignChannel } from "../../market-campaign/campaign-steps";
import { Dialog } from "../../../components/Dialogs/Dialog";

interface ISelectWhatsappTemplateProps {
  open: boolean;
  toNumber: string;
  isFromStartConversation?: boolean;
  isFromQuickReply?: boolean;
  onClose: () => void;
  onSelect?: (template: IWhatsAppTemplate) => void;
}

export const SelectWhatsappTemplate = (props: ISelectWhatsappTemplateProps) => {
  const {
    open,
    toNumber,
    onClose,

    isFromStartConversation,
    isFromQuickReply,
  } = props;

  return (
    <Dialog
      size="xl"
      open={open}
      onClose={onClose}
      title={"Select Whatsapp Template"}
    >
      <Grid container spacing={2}>
        <Grid item xs={12}>
          {/* <MarketCampaignContext.Provider value={mockCampaignContext}> */}
            {/* <Step3MarketCampaignChannel
              isFromChatModule={{
                toNumber,
                isFromStartConversation,
                isFromQuickReply,
                onClose,
              }}
            />
          {/* </MarketCampaignContext.Provider> */}
        </Grid>
      </Grid>
    </Dialog>
  );
};
